<script setup>
import Dialog from 'primevue/dialog'
import { ref, watch, onMounted, onUnmounted } from 'vue'
const props = defineProps({
  dialogId: {
    type: String,
    required: true
  },
  visible: {
    type: Boolean,
    required: false
  },
  header: {
    type: String,
    required: false
  },
  showHeaderContent: {
    type: Boolean,
    default: false
  },
  footerButtons: {
    type: Boolean,
    default: false
  },
  footerClasses: {
    type: String,
    default: ''
  },
  showCloseIcon: {
    type: Boolean,
    default: true
  },
  dismissableMask: {
    type: Boolean,
    default: true
  },
  pt: {
    type: Object,
    default: () => ({})
  }
})

const isVisible = ref(props.visible)
const emit = defineEmits(['update:visible', 'hide'])
watch(
  () => props.visible,
  (newVal) => {
    isVisible.value = newVal
  }
)
watch(isVisible, (newVal) => {
  emit('update:visible', newVal)
})

function handleEscapeKey(event) {
  if (event.key === 'Escape' && isVisible.value) {
    isVisible.value = false
    emit('hide')
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleEscapeKey)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleEscapeKey)
})
</script>
<template>
  <Dialog
    :id="dialogId"
    v-model:visible="isVisible"
    modal
    class="w-auto md:w-[718px]"
    :draggable="false"
    :dismissableMask="dismissableMask"
    :blockScroll="true"
    position="top"
    :closable="showCloseIcon"
    :pt="pt"
  >
    <div class="px-6 pb-6 pt-4">
      <slot name="bodyContent" />
    </div>
    <div v-if="footerButtons" :class="['flex justify-end gap-2 border-t border-t-gray-300 px-6 pt-4 items-center', footerClasses]">
      <slot name="footerButtonLeft" />
      <slot name="footerButtonRight" />
    </div>
    <template #closeicon>
      <span class="material-icons-round">close</span>
    </template>
    <template #header v-if="header">
      <span class="text-xl font-bold leading-7" :id="dialogId + '_header'">{{ header }}</span>
    </template>
    <template #header v-else-if="showHeaderContent">
        <slot name="headerContent" />
    </template>
  </Dialog>
</template>